module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/refresh-77fb13e8c3faf12cb41e47a0181b8916.svg";